export const QR_MARKETING_LINK = "https://qrmarketing.com/de/"
export const TERMS_AND_CONDITIONS_LINK = "https://achkarrer-wein.com/agb/"
export const IMPRINT_LINK = "https://achkarrer-wein.com/impressum/"
export const PRIVACY_POLICY_LINK = "https://achkarrer-wein.com/datenschutz/"
